import {Pipe, PipeTransform} from '@angular/core';
import {LocalizationService} from "./localization.service";
import {BehaviorSubject, Observable} from "rxjs";

@Pipe({
    name: 'localize',
    standalone: false
})
export class LocalizePipe implements PipeTransform {

  constructor(private loc: LocalizationService) {
  }

  transform(value: string, ...args: unknown[]): Observable<string> {
    let bs = new BehaviorSubject<string>(this.loc.Localize(value))
    this.loc.languages$.subscribe(() => bs.next(this.loc.Localize(value)))
    return bs.asObservable()
  }

}
